import { Icon } from '@perch-labs/shrike';
import { SpaceProps } from 'styled-system';
import { DialogSelector } from '~/components/dialogs';
import { StyledSelect } from '~/components/dropdowns/select.style';
import { OnChangeMeta } from '~/components/validating-input';
import { getStyledSystemProps } from '~/utils/styled-system';
import { copy } from './copy';

export type OnboardingRateClassOption = {
  id: number;
  displayName: string;
};

export type OnboardingRateClassIdValue = number | '';

interface OnboardingRateClassSelectProps extends SpaceProps {
  id?: string;
  onChange: (value: OnboardingRateClassIdValue, meta: OnChangeMeta) => void;
  options: readonly OnboardingRateClassOption[];
  value?: OnboardingRateClassIdValue;
}

export const OnboardingRateClassSelect = ({
  id = 'onboarding-rate-class-select',
  onChange,
  options,
  value = '',
  ...props
}: OnboardingRateClassSelectProps) => {
  const selectOptions = options.map(option => ({
    disabled: false,
    selected: false,
    text: option.displayName,
    value: String(option.id),
  }));

  const handleChange = (selectedValue: string) => {
    const nextValue: OnboardingRateClassIdValue = selectedValue
      ? Number.parseInt(selectedValue, 10)
      : '';
    onChange(nextValue, {
      isValid: nextValue !== '',
      name: 'onboardingRateClassId',
    });
  };

  const labelWithImage = (
    <DialogSelector
      type="ENROLLMENT_FIELDS"
      target={
        <p>
          {copy.label}
          <Icon icon="QuestionCircleInverted" margin={{ bottom: '2px', left: '8px' }} />
        </p>
      }
      copy={{
        fieldName: 'rateClass',
        fieldLabel: copy.label,
      }}
    />
  );

  return (
    <StyledSelect
      {...getStyledSystemProps(props)}
      disabled={false}
      id={id}
      label={labelWithImage}
      loading={false}
      minHeight="auto"
      name="onboardingRateClassId"
      onChange={handleChange}
      options={selectOptions}
      value={String(value)}
      withEmptyPlaceholder
    />
  );
};
